import { nullable } from '@abb-procure/api';
import * as t from 'io-ts';

const DailyExchangeRateResponse = t.type(
  {
    exchangeRates: t.record(t.string, t.number),
    source: nullable(t.string),
  },
  'DailyExchangeRateResponse',
);

type DailyExchangeRateResponse = t.TypeOf<typeof DailyExchangeRateResponse>;
export { DailyExchangeRateResponse };
